import { StoreIssueDoc } from '@gooduncles/gu-app-schema';
import { useMemo } from 'react';
import { getStoreIssue } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const getIssues = async (storeIssueIds: StoreIssueDoc['_id'][]) => {
  const promises = storeIssueIds.map((id) => getStoreIssue(id));
  return Promise.all(promises);
};

const useStoreIssuesByIds = (storeIssueIds: StoreIssueDoc['_id'][] | null) => {
  const {
    data,
    isLoading: storeIssuesLoading,
    error: storeIssuesError,
  } = useSWR(storeIssueIds ? storeIssueIds : null, getIssues, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });
  const storeIssues = useMemo(
    () => (data ? (data.filter((issue) => issue !== undefined) as StoreIssueDoc[]) : undefined),
    [data]
  );

  return {
    storeIssues,
    storeIssuesLoading,
    storeIssuesError,
  };
};

export default useStoreIssuesByIds;
